// FieldNoteList.js
// Displays a list of field notes with edit/delete actions

import React from "react";
import styles from "../FieldNotesTab.module.css";

// Helper function to format date consistently
// const formatDate = (dateString) => {
//   if (!dateString) return "";
//   // If it's already a formatted string like "MM/DD/YYYY", return as-is
//   if (typeof dateString === "string" && dateString.includes("/")) {
//     return dateString;
//   }
//   // Otherwise try to parse and format
//   const date = new Date(dateString);
//   if (isNaN(date.getTime())) return dateString;
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const day = String(date.getDate()).padStart(2, "0");
//   const year = date.getFullYear();
//   return `${month}/${day}/${year}`;
// };

export const FieldNoteList = ({ notes, canEdit, onEdit, onDelete }) => {
  if (!notes || notes.length === 0) {
    return (
      <div className={styles.noNotesMessage}>
        No field notes found. Click "Add Note" to create a new note.
      </div>
    );
  }

  return (
    <div className={styles.notesList}>
      {notes.map((note) => (
        <div key={note.id} className={styles.noteItem}>
          <div className={styles.noteHeader}>
            <div className={styles.noteMetadata}>
              <span className={styles.noteName}>{note.employeeName}</span>
              <span className={styles.noteDateTime}>
                {note.noteDate}
                {note.fieldNoteTime && ` at ${note.fieldNoteTime}`}
              </span>
            </div>
            {canEdit && canEdit(note) && (
              <div className={styles.noteActions}>
                <button
                  className={styles.editButton}
                  onClick={() => onEdit(note)}
                >
                  Edit
                </button>
                <button
                  className={styles.deleteButton}
                  onClick={() => onDelete(note)}
                >
                  Delete
                </button>
              </div>
            )}
          </div>
          <div className={styles.noteContent}>{note.fieldNote}</div>
        </div>
      ))}
    </div>
  );
};
